<div class="benefit-container">
  <div class="content">
    <div class="headline">{{ 'pdp.info.benefits.headline' | translate }}</div>
    <div class="body">
      <kion-accordion [items]="benefits"></kion-accordion>
    </div>
  </div>
</div>
